export const PMA_APPLICATION_LOADING = 'PMA_APPLICATION_LOADING';
export const PMA_APPLICATION_SUCCESS = 'PMA_APPLICATION_SUCCESS';
export const PMA_APPLICATION_ERROR = 'PMA_APPLICATION_ERROR';
export const INITIATE_PMA_APPLICATION = 'INITIATE_PMA_APPLICATION';
export const INITIATE_PMA_APPLICATION_SUCCESS = 'INITIATE_PMA_APPLICATION_SUCCESS';
export const INITIATE_PMA_APPLICATION_ERROR = 'INITIATE_PMA_APPLICATION_ERROR';

export const FETCH_PMA_APPLICATION = 'FETCH_PMA_APPLICATION';
export const FETCH_PMA_APPLICATION_SUCCESS = 'FETCH_PMA_APPLICATION_SUCCESS';
export const FETCH_PMA_APPLICATION_ERROR = 'FETCH_PMA_APPLICATION_ERROR';

export const FETCH_PMA_COMPANY_DETAILS = 'FETCH_PMA_COMPANY_DETAILS';
export const FETCH_PMA_COMPANY_DETAILS_SUCCESS = 'FETCH_PMA_COMPANY_DETAILS_SUCCESS';
export const FETCH_PMA_COMPANY_DETAILS_ERROR = 'FETCH_PMA_COMPANY_DETAILS_ERROR';

export const SAVE_PMA_APPLICATION = 'SAVE_PMA_APPLICATION';
export const SAVE_PMA_APPLICATION_SUCCESS = 'SAVE_PMA_APPLICATION_SUCCESS';
export const SAVE_PMA_APPLICATION_ERROR = 'SAVE_PMA_APPLICATION_ERROR';

export const CHANGE_PMA_STEP = 'CHANGE_PMA_STEP';

export const PMA_FIELD_CHANGE = 'PMA_FIELD_CHANGE';

export const UPLOAD_PMA_DOCUMENT = 'UPLOAD_PMA_DOCUMENT';
export const UPLOAD_PMA_DOCUMENT_SUCCESS = 'UPLOAD_PMA_DOCUMENT_SUCCESS';
export const UPLOAD_PMA_DOCUMENT_ERROR = 'UPLOAD_PMA_DOCUMENT_ERROR';

export const DOWNLOAD_PMA_DOCUMENT = 'DOWNLOAD_PMA_DOCUMENT';
export const DOWNLOAD_PMA_DOCUMENT_SUCCESS = 'DOWNLOAD_PMA_DOCUMENT_SUCCESS';
export const DOWNLOAD_PMA_DOCUMENT_ERROR = 'DOWNLOAD_PMA_DOCUMENT_ERROR';

export const DELETE_PMA_DOCUMENT = 'DELETE_PMA_DOCUMENT';
export const DELETE_PMA_DOCUMENT_SUCCESS = 'DELETE_PMA_DOCUMENT_SUCCESS';
export const DELETE_PMA_DOCUMENT_ERROR = 'DELETE_PMA_DOCUMENT_ERROR';

export const GET_PMA_DOCUMENTS = 'GET_PMA_DOCUMENTS';
export const GET_PMA_DOCUMENTS_SUCCESS = 'GET_PMA_DOCUMENTS_SUCCESS';
export const GET_PMA_DOCUMENTS_ERROR = 'GET_PMA_DOCUMENTS_ERROR';

export const FETCH_PMA_USER_DETAILS = 'FETCH_PMA_USER_DETAILS';
export const FETCH_PMA_USER_DETAILS_SUCCESS = 'FETCH_PMA_USER_DETAILS_SUCCESS';
export const FETCH_PMA_USER_DETAILS_ERROR = 'FETCH_PMA_USER_DETAILS_ERROR';

export const ADD_PMA_PROPERTIES = 'ADD_PMA_PROPERTIES';
export const ADD_PMA_PROPERTIES_SUCCESS = 'ADD_PMA_PROPERTIES_SUCCESS';
export const ADD_PMA_PROPERTIES_ERROR = 'ADD_PMA_PROPERTIES_ERROR';
export const ADD_PMA_VALIDATION_ERROR = 'ADD_PMA_VALIDATION_ERROR';
export const ADD_PMA_UNIT_VALIDATION_ERROR = 'ADD_PMA_UNIT_VALIDATION_ERROR';

export const REMOVE_PMA_PROPERTIES = 'REMOVE_PMA_PROPERTIES';
export const REMOVE_PMA_PROPERTIES_SUCCESS = 'REMOVE_PMA_PROPERTIES_SUCCESS';
export const REMOVE_PMA_PROPERTIES_ERROR = 'REMOVE_PMA_PROPERTIES_ERROR';

export const GET_PMA_BUILDINGS = 'GET_PMA_BUILDINGS';
export const GET_PMA_BUILDINGS_SUCCESS = 'GET_PMA_BUILDINGS_SUCCESS';
export const GET_PMA_BUILDINGS_ERROR = 'GET_PMA_BUILDINGS_ERROR';

export const GET_PMA_UNITS = 'GET_PMA_UNITS';
export const GET_PMA_UNITS_SUCCESS = 'GET_PMA_UNITS_SUCCESS';
export const GET_PMA_UNITS_ERROR = 'GET_PMA_UNITS_ERROR';

export const CHECKOUT_PMA_APPLICATION = 'CHECKOUT_PMA_APPLICATION';
export const CHECKOUT_PMA_APPLICATION_SUCCESS = 'CHECKOUT_PMA_APPLICATION_SUCCESS';
export const CHECKOUT_PMA_APPLICATION_ERROR = 'CHECKOUT_PMA_APPLICATION_ERROR';

export const DOWNLOAD_PMA_CONTRACT_DOCUMENT = 'DOWNLOAD_PMA_CONTRACT_DOCUMENT';
export const DOWNLOAD_PMA_CONTRACT_DOCUMENT_SUCCESS = 'DOWNLOAD_PMA_CONTRACT_DOCUMENT_SUCCESS';
export const DOWNLOAD_PMA_CONTRACT_DOCUMENT_ERROR = 'DOWNLOAD_PMA_CONTRACT_DOCUMENT_ERROR';

export const DOWNLOAD_PMA_APPLICATION_CONTRACT = 'DOWNLOAD_PMA_APPLICATION_CONTRACT';
export const DOWNLOAD_PMA_APPLICATION_CONTRACT_SUCCESS = 'DOWNLOAD_PMA_APPLICATION_CONTRACT_SUCCESS';
export const DOWNLOAD_PMA_APPLICATION_CONTRACT_ERROR = 'DOWNLOAD_PMA_APPLICATION_CONTRACT_ERROR';

export const GET_PMA_CANCEL_APPLICATION = 'GET_PMA_CANCEL_APPLICATION';
export const GET_PMA_CANCEL_APPLICATION_SUCCESS = 'GET_PMA_CANCEL_APPLICATION_SUCCESS';
export const GET_PMA_CANCEL_APPLICATION_ERROR = 'GET_PMA_CANCEL_APPLICATION_ERROR';

export const CLEAR_PMA_APPLICATION_ERROR = 'CLEAR_PMA_APPLICATION_ERROR';
export const PMA_FORM_ERROR = 'PMA_FORM_ERROR';

export const GET_PMA_UNITS_BY_BUILDING = 'GET_PMA_UNITS_BY_BUILDING';
export const GET_PMA_UNITS_BY_BUILDING_SUCCESS = 'GET_PMA_UNITS_BY_BUILDING_SUCCESS';
export const GET_PMA_UNITS_BY_BUILDING_ERROR = 'GET_PMA_UNITS_BY_BUILDING_ERROR';

export const FETCH_BREAKDOWN = 'FETCH_BREAKDOWN';
export const FETCH_BREAKDOWN_SUCCESS = 'FETCH_BREAKDOWN_SUCCESS';
export const FETCH_BREAKDOWN_ERROR = 'FETCH_BREAKDOWN_ERROR';

export const INITIAL_PAGE_LOAD = 'INITIAL_PAGE_LOAD';

export const UPDATE_PMA_TYPE = 'UPDATE_PMA_TYPE';

export const BANK_APPROVAL = 'BANK_APPROVAL';
export const BANK_APPROVAL_SUCCESS = 'BANK_APPROVAL_SUCCESS';
export const BANK_APPROVAL_ERROR = 'BANK_APPROVAL_ERROR';

export const PMC_SIGNATORY_APPROVAL = 'PMC_SIGNATORY_APPROVAL';
export const PMC_SIGNATORY_APPROVAL_SUCCESS = 'PMC_SIGNATORY_APPROVAL_SUCCESS';
export const PMC_SIGNATORY_APPROVAL_ERROR = 'PMC_SIGNATORY_APPROVAL_ERROR';

export const REJECT_WITH_REASON = 'REJECT_WITH_REASON';
export const REJECT_WITH_REASON_SUCCESS = 'REJECT_WITH_REASON_SUCCESS';
export const REJECT_WITH_REASON_ERROR = 'REJECT_WITH_REASON_ERROR';

export const RESET_ERROR = 'RESET_ERROR';
